var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.248 1.062a.566.566 0 0 1 .245.257l1.888 3.928 4.15.666a.575.575 0 0 1 .463.659.59.59 0 0 1-.158.323L11.852 9.99l.881 4.311a.579.579 0 0 1-.425.687.53.53 0 0 1-.357-.046L8 12.92 4.05 14.94a.541.541 0 0 1-.74-.266.603.603 0 0 1-.043-.375l.881-4.311-2.984-3.094a.598.598 0 0 1-.004-.818.544.544 0 0 1 .309-.164l4.15-.666 1.888-3.928a.54.54 0 0 1 .741-.257zm1.458 5.09L7.999 2.6 6.294 6.151l-3.862.619 2.801 2.903-.808 3.951L8 11.796l3.574 1.828-.807-3.95 2.8-2.904-3.861-.619z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.01c20724ca49a402ba2509c643644623.svg";
export { ForwardRef as ReactComponent };